import React from 'react';

const AdminAuditTab = ({ auditLogs }) => (
  <div className="space-y-6">
    <h2 className="text-xl font-bold text-white">Audit Logs</h2>

    <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl border border-[#2D5A8F] overflow-hidden">
      <table className="w-full">
        <thead className="bg-[#0F172A]">
          <tr className="text-gray-400 text-sm">
            <th className="px-4 py-3 text-left">Timestamp</th>
            <th className="px-4 py-3 text-left">Action</th>
            <th className="px-4 py-3 text-left">Actor</th>
            <th className="px-4 py-3 text-left">Target</th>
            <th className="px-4 py-3 text-left">Details</th>
          </tr>
        </thead>
        <tbody>
          {auditLogs.map((log) => (
            <tr key={log.id} className="border-b border-[#2D5A8F]/50 hover:bg-[#1E3A5F]/50">
              <td className="px-4 py-3 text-gray-400 text-sm">
                {log.timestamp ? new Date(log.timestamp).toLocaleString() : '-'}
              </td>
              <td className="px-4 py-3">
                <span className="px-2 py-1 bg-[#1E3A5F] text-[#FFD700] rounded text-xs">{log.action}</span>
              </td>
              <td className="px-4 py-3 text-white">
                {log.user_name || log.actor_name || '-'}
                {(log.user_role || log.actor_role) && (
                  <span className="text-gray-500 text-xs"> ({log.user_role || log.actor_role})</span>
                )}
              </td>
              <td className="px-4 py-3 text-gray-300">{log.target_name || log.target_type || '-'}</td>
              <td className="px-4 py-3 text-gray-400 text-sm max-w-xs truncate">{log.details || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {auditLogs.length === 0 && (
        <p className="text-gray-400 text-center py-8">No audit logs found</p>
      )}
    </div>
  </div>
);

export default AdminAuditTab;
